/**
 * @file openBox
 * @author yanyiting <yanyiting@baidu.com>
 */

import invokeApp from './invokeApp';
import showWeiXinTips from './showWeiXinTips';

export {invokeApp, showWeiXinTips};
